module.exports = __webpack_public_path__ + "media/Z45.da41ecb3.mp3";